// extracted by mini-css-extract-plugin
module.exports = {"header":"header__2nJI2","content":"content__HSOQ1","actionButtons":"actionButtons__3U3Co"};